import axios from "../../utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  purchaseOrderConfiguration: {},
};

const purchaseOrderConfigurationSlice = createSlice({
  name: "purchaseOrderConfiguration",
  initialState,
  reducers: {
    setPurchaseOrderConfiguration(state, action) {
      state.purchaseOrderConfiguration = action.payload;
    },
  },
});

export function getPurchaseOrderConfiguration() {
  return async (dispatch) => {
    const impersonationToken = localStorage.getItem("impersonationToken");
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No token");
    try {
      const token = impersonationToken ? impersonationToken : accessToken;
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/purchase-order-config`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(
        purchaseOrderConfigurationSlice.actions.setPurchaseOrderConfiguration(
          response.data.data
        )
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      dispatch(
        purchaseOrderConfigurationSlice.actions.setMailConfiguration({})
      );
      return Promise.reject(error.message);
    }
  };
}

export function updatePurchaseOrderConfiguration({ data }) {
  return async (dispatch) => {
    console.log(data);
    const impersonationToken = localStorage.getItem("impersonationToken");
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No token");
    try {
      const token = impersonationToken ? impersonationToken : accessToken;
      const response = await axios.put(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/purchase-order-config`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(
        purchaseOrderConfigurationSlice.actions.setPurchaseOrderConfiguration(
          response.data.data
        )
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      dispatch(
        purchaseOrderConfigurationSlice.actions.setPurchaseOrderConfiguration(
          {}
        )
      );
      return Promise.reject(error.message);
    }
  };
}

export default purchaseOrderConfigurationSlice.reducer;
